import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CreateProjectPortfolioError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: CreateProjectPortfolioError;
  createProjectPortfolio(
    request: Boundaries["createProjectPortfolio"]["request"],
  ): void;
}

function useCreateProjectPortfolio(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isCreateProjectPortfolioRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isCreateProjectPortfolioRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isCreateProjectPortfolioRequestFailure,
    ),
    error: useSelector(selector.getCreateProjectPortfolioError),
    createProjectPortfolio: core.createProjectPortfolio,
  };
}

export { useCreateProjectPortfolio };
